import {
  useQuery,
  useMutation,
  UseQueryOptions,
  UseMutationOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

export function useApiQuery<TData, TError = AxiosError>(
  key: unknown[],
  queryFn: () => Promise<TData>,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">
) {
  return useQuery<TData, TError>({
    queryKey: key,
    queryFn,
    throwOnError: true,
    refetchOnWindowFocus: true,
    ...options,
  });
}

export function useApiMutation<TData, TVariables, TError = AxiosError>(
  mutationFn: (data: TVariables) => Promise<TData>,
  options?: UseMutationOptions<TData, TError, TVariables>
) {
  return useMutation<TData, TError, TVariables>({
    mutationFn,
    ...options,
  });
}
